// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3524 ? "2170a4aa" : chunkId) + "." + {"3524":"d83fac6bb29a7e65","8436":"39669319b9f31b0a"}[chunkId] + ".js";
};